module.exports = __webpack_public_path__ + "img/img5.ad4b9fe8.png";